const src = require("/app/src/assets/images/svg/renzy-logo.svg?as-resource");
const img = new String(src);
img.src = src;
img.width = 137;
img.height = 42;
img.toString = function() { return src; };
module.exports = img;